import { render } from "./RfContacto.vue?vue&type=template&id=b6c60826"
import script from "./RfContacto.vue?vue&type=script&lang=js"
export * from "./RfContacto.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__